import { render, staticRenderFns } from "./RelatedThresholdApply.vue?vue&type=template&id=0d8e806c&scoped=true&"
import script from "./RelatedThresholdApply.vue?vue&type=script&lang=js&"
export * from "./RelatedThresholdApply.vue?vue&type=script&lang=js&"
import style0 from "./RelatedThresholdApply.vue?vue&type=style&index=0&id=0d8e806c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8e806c",
  null
  
)

export default component.exports